import DialogComponent from "components/Dialog";

export default class CopyTratPlanDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.defaultState = {
            ...this.state,
            title: "",
        };

        this.state = { ...this.defaultState };
    }

    title = "main.createCopy";

    show(info, hideCb) {
        this.info = info;
        this.hidCb = hideCb;

        this.state.title = (info.title || "") + " " + this.tr("main.copy");

        super.show();
    }

    onShow() {
        this.titleNode.value = this.state.title;
    }
    
    onInputChange(value) {
        this.state.title = value;
    }

    save() {
        const { title } = this.state;

        if (!title)
            return;

        if (this.hidCb?.apply)
            this.hidCb(this.info.id, { title });

        this.hide();
    }

    renderContent() {
        return (
            <div className="content flex col gap16">
                {this.insertInput({
                    ref: el => this.titleNode = el,
                    label: "main.name",
                    placeHolder: "main.name",
                    onChange: this.onInputChange.bind(this)
                })}
            </div>
        );
    }
}
